import React from "react";

import { Access } from "common";
import { Form } from "components";
import { Regions, Stores } from "components/Filters";

export default function Filters({ data, onChange, onClean }) {
  const storeFilters = { regions: [data.region] };

  return (
    <Form className="row form-filters">
      <Form.Field className="col-md-2">
        <Form.Label>Regiões</Form.Label>
        <Regions
          value={data.region}
          onChange={(value) => onChange("region", value)}
        />
      </Form.Field>

      <Form.Field className="col-md-4">
        <Form.Label>Lojas</Form.Label>
        <Stores
          isMulti
          value={data.stores}
          onChange={(value) => onChange("stores", value)}
          isDisabled={!!Access.lockedStore()}
          filters={storeFilters}
        />
      </Form.Field>

      <Form.Field className="col-md-2">
        <Form.Label>Período, de</Form.Label>
        <Form.Icon name="calendar">
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={data.date_start}
            onChange={(value) => onChange("date_start", value)}
          />
        </Form.Icon>
      </Form.Field>

      <Form.Field className="col-md-2">
        <Form.Label>Período, até</Form.Label>
        <Form.Icon name="calendar">
          <Form.DatePicker
            dateFormat="dd/MM/yyyy"
            selected={data.date_end}
            onChange={(value) => onChange("date_end", value)}
            minDate={data.date_start}
            disabled={data.date_start === null}
          />
        </Form.Icon>
      </Form.Field>

      <Form.Field className="col-md-3">
        <Form.Button className="button-clean-filter" onClick={onClean}>
          Resetar Filtro
        </Form.Button>
      </Form.Field>
    </Form>
  );
}
